import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

import { StyledCell } from "./Cell";

const StyledGroup = styled.div`
  display: flex;
  flex-direction: column;
  ${({ width }) =>
    width
      ? css`
          width: ${width}px;
          max-width: ${width}px;
        `
      : css`
          margin-right: auto;
        `}
  ${StyledCell} {
    padding: 3px 12px;
    &:first-child {
      padding-top: 12px;
    }
    &:last-child {
      padding-bottom: 12px;
    }
  }
`;

function Group({ children, ...props }) {
  return <StyledGroup {...props}>{children}</StyledGroup>;
}

Group.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
};

export default Group;
